import httpService from './httpService';
import storageService from '../services/StorageService';

// USER APPLIES TO THE SERVICE
async function apply(userInfo) {
  const mail = await httpService.post('mail/apply', userInfo);
  console.log('MAIL SENT', mail);
  return mail
}

// GET USER FROM STORAGE
function getLoggedInUser() {
  return storageService.getStorage('user')
}

// GET USERS FROM DB
async function getUsers() {
  return await httpService.get('user')
}

// GET USER BY ID
async function getUsersById(userId) {
  return await httpService.get(`user/${userId}`)
}

// EDIT USER
async function editUser(user) {
  return await httpService.put(`user/${user._id}`, user)
}

// DELETE USER
async function removeUser(userId) {
  return await httpService.delete(`user/${userId}`)
}

// PASSWORD RESET REQUEST
async function forgotPassword(email) {
  const res = await httpService.post('mail/forgot', {email} );
  return res;
}

async function verifyEmail(email) {
  const res = await httpService.post('user/verify-email', {email})
  return !!res
  
}

function getEmptyUser() {
  return {
    fullName: "",
    company: "",
    email: "",
    phone: "",
    streetAddress: "",
    city: "",
    password: "",
    permission: ""
  }
}


export default {

  apply,
  getLoggedInUser,
  getUsers,
  getUsersById,
  getEmptyUser,
  editUser,
  removeUser,
  forgotPassword,
  verifyEmail

}